import render from './render'

export default {
  name: 'Host',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  render
}
